import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ReceiptDownload = ({ transaction }) => {
  const [email, setEmail] = useState('john.doe@example.com');
  const [emailSent, setEmailSent] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const handleDownloadReceipt = () => {
    setIsDownloading(true);
    // Simulate PDF generation and download
    setTimeout(() => {
      setIsDownloading(false);
      // In real app, this would trigger actual PDF download
      alert('Receipt downloaded successfully!');
    }, 1500);
  };

  const handleEmailReceipt = () => {
    setIsSendingEmail(true);
    // Simulate email sending
    setTimeout(() => {
      setIsSendingEmail(false);
      setEmailSent(true);
      setTimeout(() => setEmailSent(false), 3000);
    }, 1500);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-warm-sm">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="FileText" size={20} className="text-primary" />
        <h2 className="text-lg font-heading font-bold text-foreground">
          Receipt & Invoice
        </h2>
      </div>
      <div className="space-y-4">
        {/* Receipt Preview */}
        <div className="bg-gradient-to-br from-muted/30 to-muted/10 rounded-lg p-6 border border-border">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-sm font-semibold text-foreground">JOB Fusion</p>
              <p className="text-xs text-muted-foreground">Tax Invoice</p>
            </div>
            <div className="bg-primary/10 text-primary px-3 py-1 rounded text-xs font-semibold">
              PAID
            </div>
          </div>

          <div className="space-y-2 mb-4">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Invoice No.</span>
              <span className="font-mono text-foreground">{transaction?.id}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Date</span>
              <span className="text-foreground">
                {new Date(transaction?.timestamp)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Plan</span>
              <span className="text-foreground">{transaction?.plan?.name}</span>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold text-foreground">Total Amount</span>
              <span className="text-lg font-heading font-bold text-primary">
                ${transaction?.amount}
              </span>
            </div>
          </div>
        </div>

        {/* Download Button */}
        <Button
          variant="default"
          size="lg"
          fullWidth
          iconName="Download"
          onClick={handleDownloadReceipt}
          loading={isDownloading}
        >
          {isDownloading ? 'Generating PDF...' : 'Download Receipt (PDF)'}
        </Button>

        {/* Email Receipt Section */}
        <div className="pt-4 border-t border-border">
          <p className="text-sm font-medium text-foreground mb-3">Email Receipt</p>
          <div className="space-y-3">
            <Input
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
            />
            <Button
              variant="outline"
              size="default"
              fullWidth
              iconName="Mail"
              onClick={handleEmailReceipt}
              loading={isSendingEmail}
            >
              {isSendingEmail ? 'Sending...' : 'Send to Email'}
            </Button>
            {emailSent && (
              <div className="flex items-center gap-2 text-sm text-success bg-success/10 rounded-lg p-3">
                <Icon name="CheckCircle" size={16} />
                <span>Receipt sent to {email}</span>
              </div>
            )}
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-muted/30 rounded-lg p-4 space-y-2">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={14} className="text-accent mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              A copy of this receipt has been automatically sent to your registered email address.
            </p>
          </div>
          <div className="flex items-start gap-2">
            <Icon name="FileText" size={14} className="text-accent mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              You can access all your invoices anytime from your billing history.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptDownload;